import React, { useState, useEffect } from "react";
import deleteitem from "../../../components/Images/deleteitem.svg";
import edititem from "../../../components/Images/edititem.svg";
import axios from "axios";
import { Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdDelete, MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName } from "../../../components/CommonMethod/CommonMethods";
import { RxReload } from "react-icons/rx";
import { IoClose } from 'react-icons/io5';
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import { connect } from "react-redux";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { width } from "@mui/system";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import BootstrapTable from "react-bootstrap-table-next";
import { toast } from 'react-toastify';
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { FaEllipsisVertical } from "react-icons/fa6";
import AdminAgeWarningModal from "./AdminAgeWarningModal";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";

// Delete Confirmation Modal Component
const DeleteConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  itemName = "item"
}) => {
  if (!show) return null;

  return (
    <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Deletion</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            Are you sure you want to delete this {itemName}?
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger" onClick={onConfirm}>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function ManageAge(props) {
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const [data, setData] = useState([]);

  // Delete Modal State
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
    itemName: "age category"
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Baseurl}/admin/age-category/index`,
          { headers }
        );
        setApiData(response?.data?.Age_Categories);
        setFilteredData(response?.data?.Age_Categories);
        setCountage(response?.data?.Total_count);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  const openDeleteModal = (id) => {
    setDeleteModal({
      show: true,
      id: id,
      itemName: "age category"
    });
  };

  const closeDeleteModal = () => {
    setDeleteModal({
      show: false,
      id: null,
      itemName: "age category"
    });
  };

  const handleConfirmDelete = () => {
    if (!deleteModal.id) return;

    axios
      .delete(`${process.env.REACT_APP_Baseurl}/admin/age-category/delete/${deleteModal.id}`, { headers })
      .then(response => {
        if (response.data.status) {
          setApiData(prev => prev.filter(item => item.id !== deleteModal.id));
          setFilteredData(prev => prev.filter(item => item.id !== deleteModal.id));
          toast.success("Age category deleted successfully!");
        } else {
          toast.error("Failed to delete age category.");
        }
      })
      .catch(error => {
        console.error("Delete error:", error);
        toast.error("An error occurred while deleting.");
      })
      .finally(() => closeDeleteModal());
  };
  const [dataage, setDataage] = useState([]);
  const [pageage, setPageage] = useState(1);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [videodataage, setVideodataage] = useState("");
  const [defaultImage, setDefaultimage] = useState();
  const [defaultImageurl, setDefaultimageurl] = useState("");
  const [currentPageage, setCurrentPageage] = useState(1);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [filter, setFilter] = useState('');
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [countage, setCountage] = useState(0);
  const [showAgeWarningModal, setShowAgeWarningModal] = useState(false);
  const itemsPerPageage = 10;

  const videosdeleteOperationage = (id) => {
    const access_token = localStorage.getItem("access_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    };
    axios
      .delete(
        `${process.env.REACT_APP_Baseurl}/admin/age-category/delete/` + id,
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.data.status == true) {
          var responseData = response.data;
          props.setApiresponsealert(responseData);
          props.setShowalert(true);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          if (responseData === false) {
            var resultError = responseData;
            props.setApiresponsealert(resultError);
            props.setShowalert(true);
          }
        }
      });
  };

  const ActionFormatterComponent = ({ row, action }) => {
    return (
      <div className="editdropdown">
        <span className="editdropdown-button">
          <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
        </span>
        <div className="editdropdown-menu p-2">
          <Link
            to={`/edit/manage-age/${row.id}`}
            className="theme-text-color theme-bg-color w-100 d-block p-2"
          >
            <img src={edititem} alt="edit" width={20} height={20} />
            <span className="ms-2">Edit</span>
          </Link>
          <button
            onClick={() => action(row.id)}
            className="w-100 p-2 d-block theme-text-color theme-bg-color"
          >
            <img src={deleteitem} alt="delete" width={20} height={20} />
            <span className="ms-2">Delete</span>
          </button>
        </div>
      </div>
    );
  };

  const columns = [
    {
      dataField: "age",
      text: "Age",
      formatter: (cell, row) => cell,
      headerStyle: { width: '25%' },
      style: { width: '25%' },
    },
    {
      dataField: "slug",
      text: "Age Slug Name",
      formatter: (cell, row) => <MessageBox text={cell?.replaceAll("_", " ")} />
    },
    {
      dataField: "id",
      text: "Actions",
      formatter: (cell, row) => (
        <div className="editdropdown">
          <span className="editdropdown-button">
            <FaEllipsisVertical className="theme-text-color" />
          </span>
          <div className="editdropdown-menu p-2">
            <Link
              to={`/edit/manage-age/${row.id}`}
              className="theme-text-color theme-bg-color w-100 d-block p-2"
            >
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text={`Edit`} classname='ms-2 theme-text-color'></MessageBox>
            </Link>
            <button
              onClick={() => openDeleteModal(row.id)}
              className="w-100 p-2 d-block theme-text-color theme-bg-color"
            >
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text={`Delete`} classname='ms-2 theme-text-color'></MessageBox>
            </button>
          </div>
        </div>
      ),
    }
  ];

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const closeModal = () => {
    setModelClose((prev) => !prev);
    setItemToDelete([])
  };

  const handleFilter = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);

    if (searchTerm.trim() === '') {
      setFilteredData(apiData); // reset to full list
      return;
    }

    const filteredResults = apiData.filter((item) =>
      ["age", "age_slug_name"].some((property) =>
        typeof item[property] === "string" &&
        item[property].toLowerCase().includes(searchTerm)
      ) ||
      (typeof item.sno === "number" &&
        item.sno.toString().includes(searchTerm))
    );

    setFilteredData(filteredResults);
  };

  const handleClear = () => {
    setFilter('');
    setFilteredData(apiData); // reset to full list
  };

  const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="btn-group" role="group">
      <select
        className="form-select custom-page-select"
        value={currSizePerPage}
        onChange={(e) => onSizePerPageChange(e.target.value)}
      >
        {options.map((opt) => (
          <option key={opt.page} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>
    </div>
  );

  const options = {
    sizePerPageRenderer: sizePerPageRenderer,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: 'Next',
    prePageText: 'Prev',
    firstPageText: <span><MdKeyboardDoubleArrowLeft /></span>,
    lastPageText: <span><MdKeyboardDoubleArrowRight /></span>,
    showTotal: true,
    alwaysShowAllBtns: true,
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '50px' },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const [selectedItemsage, setSelectedItemsage] = useState([]);
  const [selectAllage, setSelectAllage] = useState(false);
  const [isConfirmationOpenage, setIsConfirmationOpenage] = useState(false);
  const [isSuccessMessageOpenage, setIsSuccessMessageOpenage] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);


  const handleSingleSelectage = (itemId) => {
    setSelectedItemsage([itemId]);
    setSelectAllage(false);
  };

  const handleMultiSelectage = (itemId) => {
    if (selectedItemsage.includes(itemId)) {
      setSelectedItemsage(selectedItemsage.filter((id) => id !== itemId));
    } else {
      setSelectedItemsage([...selectedItemsage, itemId]);
    }
  };

  const handleSelectAllage = () => {
    setSelectAllage(!selectAllage);
    setSelectedItemsage(
      selectAllage ? [] : videodataage.map((item) => item?.id)
    );
  };

  const handleDeleteage = () => {
    setIsConfirmationOpenage(true);
  };


  const handleCancelDeleteage = () => {
    setIsConfirmationOpenage(false);
  };

  const handleConfirmDeleteage = () => {
    // setIsConfirmationOpenage(false);
    setProcessing(true);
    setShowOverlay(true);
    setIsDeleting(true); // ✅ Start loading on button

    const deletePromises = itemToDelete.map(itemId =>
      axios.delete(
        `${process.env.REACT_APP_Baseurl}/admin/age-category/delete/${itemId}`,
        { headers: headers }
      )
    );

    Promise.all(deletePromises)
      .then(responses => {
        let hasFailure = false;

        for (const response of responses) {
          if (response.data.status !== true) {
            hasFailure = true;
            const resultError = response.data;
            toast.error(resultError.message || "Failed to delete item.");
            props.setApiresponsealert(resultError);
            props.setShowalert(true);
          }
        }

        if (!hasFailure) {
          toast.success("Items deleted successfully.");
          props.setApiresponsealert({ message: "Items deleted successfully.", status: true });
          props.setShowalert(true);

          setItemToDelete([]);
          setIsSuccessMessageOpenage(true);
          setTimeout(() => {
            setIsSuccessMessageOpenage(false);
            setIsDeleting(false); // ✅ End loading
            setProcessing(false);
            setShowOverlay(false);
            window.location.reload(); // Reload after delete
          }, 2000);
        } else {
          setIsDeleting(false); // ✅ End loading
          setProcessing(false);
          setShowOverlay(false);
        }
      })
      .catch(error => {
        const apiError =
          error?.response?.data?.message || error?.message || "An unexpected error occurred.";
        toast.error(apiError);
        setIsDeleting(false); // ✅ End loading
        setProcessing(false);
        setShowOverlay(false);
      });
  };


  const fetchDatanextpreage = () => {
    axios
      .get(
        `${process.env.REACT_APP_Baseurl}/admin/age-category/index?page=${pageage}`,
        {
          headers: headers,
        }
      )
      .then((res) => {
        const videosData = res?.data?.Age_Categories;
        setVideodataage(videosData);
        if (videosData.length > 0) {
          setDataage(videosData);
          setLoading(false);
        } else {
          setDataage([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchDataage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/age-category/index`,
        { headers: headers }
      );
      setCountage(response?.data?.Total_count);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const [showModalage, setShowModalage] = useState(false);
  const [currentItemage, setCurrentItemage] = useState(null);

  const handleToggleage = async (item) => {
    setCurrentItemage(item);
    setShowModalage(true);
  };

  const confirmToggleage = async () => {
    try {
      setShowModalage(false);
      const newStatus = currentItemage.banner === 1 ? 0 : 1;

      const response = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/live-stream/livestream-slider`,
        {
          method: "POST",
          body: JSON.stringify({
            live_id: currentItemage.id,
            banner_status: newStatus,
          }),
          headers: headers,
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        const updatedItems = dataage.map((currItem) => {
          if (currItem.id === currentItemage.id) {
            return { ...currItem, banner: newStatus };
          }
          return currItem;
        });

        setDataage(updatedItems);

        props.setApiresponsealert(responseData);
        props.setShowalert(true);
        setMessage(responseData.message);
      } else {
        props.setApiresponsealert(responseData);
        props.setShowalert(true);
      }
    } catch (error) { }
  };

  const closeModalsliderage = () => {
    setShowModalage(false);
    setCurrentItemage(null);
  };

  const fetchdefaultimageage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Vertical-Default-Image`,
        { headers: headers }
      );
      setDefaultimage(response?.data?.Vertical_Default_Image);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchdefaultimageurlage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Default-image-url`,
        { headers: headers }
      );
      setDefaultimageurl(response?.data?.Default_Image_Url);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const indexOfLastItemage = currentPageage * itemsPerPageage;
  const indexOfFirstItemage = indexOfLastItemage - itemsPerPageage;
  const currentItemsage = dataage?.slice(
    indexOfFirstItemage,
    indexOfLastItemage
  );

  const handlePreClickage = () => {
    if (pageage > 1) {
      setPageage(pageage - 1);
    }
  };

  const handleNxtClickage = () => {
    setPageage(pageage + 1);
  };

  const [itemToDeleteage, setItemToDeleteage] = useState(null);
  const [successMessageage, setSuccessMessageage] = useState("");

  const openModalage = (id) => {
    setItemToDeleteage(id);
    setSuccessMessageage("");
  };

  const closeModalage = () => {
    setItemToDeleteage(null);
  };

  const handleDeletedata = () => {
    closeModalage();
    if (itemToDeleteage) {
      videosdeleteOperationage(itemToDeleteage);
    }
  };

  useEffect(() => {
    fetchDataage();
    fetchdefaultimageage();
    fetchdefaultimageurlage();
    fetchDatanextpreage();
  }, [pageage]);

  return (
    <>
      <AdminAgeWarningModal show={showAgeWarningModal} handleClose={() => setShowAgeWarningModal(false)} />
      <DeleteConfirmationModal
        show={deleteModal.show}
        onClose={closeDeleteModal}
        onConfirm={handleConfirmDelete}
        itemName={deleteModal.itemName}
      />

      <div
        className={`modal ${itemToDeleteage !== null ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: itemToDeleteage !== null ? "block" : "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Deletion</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeModalage}
              ></button>
            </div>
            <div className="modal-body">
              {successMessageage ? (
                <div className="alert alert-success" role="alert">
                  {successMessageage}
                </div>
              ) : (
                <p>Are you sure you want to delete this Category?</p>
              )}
            </div>
            <div className="modal-footer">
              {successMessageage ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={closeModalage}
                >
                  Close
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModalage}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDeletedata}
                  >
                    Yes
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >


        <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              {isConfirmationOpenage && (
                <>
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Deletion</h5>
                    <button type="button" className="btn-close" onClick={handleCancelDeleteage}
                      data-bs-dismiss="modal"
                      aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    Are you sure you want to delete this ?
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary"
                      onClick={handleCancelDeleteage}
                      data-bs-dismiss="modal"
                      aria-label="Close">
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleConfirmDeleteage}
                      disabled={isDeleting}
                    >
                      {isDeleting ? "Deleting..." : "Delete"}
                    </button>

                  </div>
                </>
              )}

            </div>
          </div>
        </div>

        {/* <div className="modal-dialog delete_confirm">
          <div className="modal-content text-center">
            <div className="modal-body">
              {isConfirmationOpenage && (
                <div>
                  <h5 className="modal-title p-3" id="exampleModalLabel">
                    <p className="fs-6">
                      Are you sure you want to delete the selected items?
                    </p>
                  </h5>
                  <div className="col-lg-12 row p-4">
                    <div className="col-lg-6">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          handleConfirmDeleteage();
                        }}
                      >
                        Confirm
                      </button>
                    </div>
                    <div className="col-lg-6">
                      <button
                        className="btn btn-primary"
                        onClick={handleCancelDeleteage}
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {isSuccessMessageOpenage && (
                <div className="success-message">
                  <div className="p-5">
                    <i className="fa fa-check" aria-hidden="true"></i>
                  </div>
                  <p className="fs-6 fw-bold">
                    Selected items have been successfully deleted.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div> */}
      </div>

      <div className=" m-0 p-0">
        <div className="container-fluid">
          <section className="section all-video-stream ">
            <div className="col-lg-12 row py-3">
              <div className="col-6 d-flex align-items-center gap-2">
                <h4 className="admin-title mb-0 theme-text-color text-md-start">
                  Age Category
                </h4>
                <p className="theme-text-color mt-0 admin-input-title d-block position-relative">
                  (Display all {countage} Age Category)
                </p>
              </div>

              <div className="col-6 d-flex justify-content-end align-items-center gap-2">
                {itemToDelete.length > 0 && (
                  <button type="button" className="warningColorBg p-2 rounded-2 d-inline-flex align-items-center "
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={handleDeleteage}>
                    <MdDelete className="exportIcon me-1" fill="#fff" />
                    <MessageBox text='Delete' classname='admin-button-text ' />
                  </button>
                )}

                <AdminCustomButton
                  saveText="Age Warning"
                  saveMethod={() => setShowAgeWarningModal(true)}
                  className="me-2"
                />

                <Link to="/add-age">
                  <button
                    type="button"
                    className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                  >
                    Add Age
                  </button>
                </Link>
              </div>
            </div>


            <div className="theme-bg-color p-4  rounded-3 bootstrapTable multi-delete-width">
              <div className="filterContainer">
                <input type='text' placeholder="Search" id='filter-search' className="filter form-control theme-text-color theme-border-secondary" value={filter} onChange={(event) => handleFilter(event)} />
                {filter?.length > 0 && (<button type="button" className="clearBtn" onClick={() => handleClear()}  ><IoClose className="custom-close-btn" /> </button>)}
              </div>

              <div style={{ position: 'relative' }}>
                {
                  loading ? (
                    <div className="text-center py-5">
                      <Defaultloadinggif />
                    </div>
                  ) : (
                    <BootstrapTable
                      keyField="id"
                      data={filteredData}
                      columns={columns}
                      pagination={paginationFactory(options)}
                      noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />}
                      selectRow={selectRow}
                    />
                  )
                }
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default ManageAge;